let marked = false;

/**
 * Tells Prerender.io this route has async content still loading, so it should wait
 * for markPrerenderReady() instead of falling back to its own network-idle
 * heuristic (which races the fetch — see the #1320 recon doc).
 *
 * Call this ONLY from a route whose crawl-relevant content depends on an async
 * fetch, as early as possible in its mount (before dispatching that fetch) — never
 * globally at app boot. A route with no such dependency should never touch
 * `window.prerenderReady` at all, so Prerender.io keeps using its own default
 * heuristic for it. Setting `window.prerenderReady = false` app-wide was tried and
 * reverted: it left every OTHER route with the flag permanently false and nothing
 * to ever flip it, so Prerender.io idled out its full render timeout on every
 * single crawl of every non-data-dependent page — a site-wide latency regression
 * this helper's per-route opt-in avoids.
 */
export function holdPrerenderReady() {
  marked = false;
  window.prerenderReady = false;
}

/**
 * Tells Prerender.io the route's critical async data has settled and it's safe to
 * snapshot. Idempotent — safe to call from a `.finally()` on every fetch settle
 * (success or failure) without re-triggering anything after the first call for
 * this page load.
 */
export function markPrerenderReady() {
  if (marked) return;
  marked = true;
  window.prerenderReady = true;
}
